import React from "react";
import convertId from "../../utilities/convert-id";
import { graphql } from "gatsby";
import Content from "../utilities/content";
import CmsImage from "../utilities/cms-image";
import CmsLink from "../utilities/cms-link";

const ContentWithImageAndBackground = ({ data }) => {
  return (
    <section
      id={convertId(data.name)}
      className={`section content-with-image-and-bg clipped-small-top ${
        data.removeBackgroundClipFromBottom ? "remove-btm-clip" : ""
      } ${data.textColor === "white" ? "text-white" : ""} ${
        data.backgroundColor === "custom"
          ? ""
          : data.backgroundColor === "white"
          ? "bg-white"
          : "bg-gray"
      }
      ${data.textColor === "white" ? "text-white" : ""}`}
      style={{
        ...(data.backgroundColor === "custom" && {
          backgroundColor: data.customBackgroundColor,
        }),
        ...(data.textColor === "white" && { color: data.textColor }),
      }}
    >
      {data.backgroundImage && (
        <CmsImage className="section-img" image={data.backgroundImage} />
      )}
      <div className="container sz">
        <div className="row">
          {data.content && (
            <div className="col-12 col-lg-6 mb-5 mb-lg-0 px-5">
              <Content className="content-two-cols">{data.content}</Content>
              {data.contentButton && (
                <CmsLink
                  className={`btn ${
                    data.contentButtonWhite ? "btn-white" : "btn-primary"
                  } btn-arrow`}
                  link={data.contentButton}
                  whiteBtn={data.contentButtonWhite}
                />
              )}
            </div>
          )}
          {data.image && (
            <div className="col-12 col-lg-6 mb-5 mb-lg-0 text-center px-5 d-flex flex-column justify-content-center">
              <CmsImage
                image={data.image}
                className={data.imageCroppedCorner ? "img-clipped" : ""}
              />
              {data.imageButton && (
                <CmsLink
                  className={`btn ${
                    data.imageButtonWhite ? "btn-white" : "btn-primary"
                  } mt-5 btn-arrow`}
                  link={data.imageButton}
                  whiteBtn={data.imageButtonWhite}
                />
              )}
            </div>
          )}
        </div>
      </div>
    </section>
  );
};

export const query = graphql`
  fragment ContentWithImageAndBackground on WpPage_Sections_Sections_ContentWithImageAndBackground {
    fieldGroupName
    name
    removeBackgroundClipFromBottom
    hideSection
    backgroundImage {
      altText
      localFile {
        childImageSharp {
          gatsbyImageData
        }
        extension
        publicURL
      }
    }
    backgroundColor
    customBackgroundColor
    content
    textColor
    contentButton {
      target
      title
      url
    }
    contentButtonWhite
    image {
      altText
      localFile {
        childImageSharp {
          gatsbyImageData
        }
        extension
        publicURL
      }
    }
    imageCroppedCorner
    imageButton {
      target
      title
      url
    }
    imageButtonWhite
  }
`;

export default ContentWithImageAndBackground;
